module.exports = __webpack_public_path__ + "img/slide_4.5a36be15.jpg";